export const PASSWORD_RULES = [
  { key: 'length', test: (v: string) => v.length >= 8 },
  { key: 'case', test: (v: string) => /[a-zçğıöşü]/.test(v) && /[A-ZÇĞİÖŞÜ]/.test(v) },
  { key: 'digit', test: (v: string) => /\d/.test(v) },
  { key: 'symbol', test: (v: string) => /[^\p{L}\d\s]/u.test(v) },
] as const
